import { createContext } from 'react'
import { KoreanLanguageContextProps } from '../types'

export const KoreanLanguageContext = createContext<KoreanLanguageContextProps>({} as KoreanLanguageContextProps)
